import { jwtDecode } from 'jwt-decode';

interface JWTPayload {
    sub: string;
    roles: string[];
    exp: number;
    iat?: number;
    [key: string]: any;
}

export interface DecodedUser {
    id: string;
    roles: string[];
    exp: number;
    iat?: number;
}

export const jwtUtils = {
    /**
     * Decode JWT token and extract user information
     * @param token - JWT token string
     * @returns Decoded user information or null if invalid
     */
    decodeToken: (token: string): DecodedUser | null => {
        try {
            const decoded = jwtDecode<JWTPayload>(token);
            
            return {
                id: decoded.sub,
                roles: decoded.roles || [],
                exp: decoded.exp,
                iat: decoded.iat,
            };
        } catch (error) {
            console.error('Failed to decode JWT token:', error);
            return null;
        }
    },

    /**
     * Check if JWT token is expired
     * @param token - JWT token string
     * @returns true if token is expired, false otherwise
     */
    isTokenExpired: (token: string): boolean => {
        try {
            const decoded = jwtDecode<JWTPayload>(token);
            const currentTime = Math.floor(Date.now() / 1000);
            return decoded.exp < currentTime;
        } catch (error) {
            console.error('Failed to check token expiration:', error);
            return true; // Consider invalid tokens as expired
        }
    },

    /**
     * Get user roles from JWT token
     * @param token - JWT token string
     * @returns Array of user roles or empty array if invalid
     */
    getUserRoles: (token: string): string[] => {
        const decoded = jwtUtils.decodeToken(token);
        console.log("decoded?.roles", JSON.stringify(decoded?.roles));
        return decoded?.roles || [];
    },

    /**
     * Get user ID from JWT token
     * @param token - JWT token string
     * @returns User ID or null if invalid
     */
    getUserId: (token: string): string | null => {
        const decoded = jwtUtils.decodeToken(token);
        return decoded?.id || null;
    },
}; 